import { createContext, useContext, useEffect, useState } from "react";
import { api, registerCurrencies } from "@/lib/api";

const Ctx = createContext({ countries: [], byCode: {} });

export function CountriesProvider({ children }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    api.get("/countries")
      .then(({ data }) => {
        registerCurrencies(data);
        setState({ countries: data, byCode: Object.fromEntries(data.map((c) => [c.code, c])) });
      })
      .catch(() => setState({ countries: [], byCode: {} }));
  }, []);
  if (!state) return null;
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export const useCountries = () => useContext(Ctx);
